var shopID = '20c74b4a7a0b2bdc446c98ca3d3450b1';
var GSenabledProductList = [10227991740728];

// Pixel Flow configuration
var PFenabledProductList = [10227991740728, 7845441601752]; // Add product IDs that should use Pixel Flow
var PFenabledTemplateSuffixes = ['dtf-transfer']; // Template suffixes for Pixel Flow
var PFenabledTags = ['pixel-flow']; // Product tags for Pixel Flow
var PFiframeUrl = 'https://benvithdjc.us-east-1.awsapprunner.com/iframes/by-image-size?shop_id=sales@blinddog-graphics.com&token=8556a0cfcf99e9bf&ts=1758568476';

// Check if current product should use Pixel Flow
function isPixelFlowProduct(productId, templateSuffix, tags) {
  return PFenabledProductList.includes(productId) || 
         PFenabledTemplateSuffixes.includes(templateSuffix) ||
         (tags && tags.some(tag => PFenabledTags.includes(tag)));
}

async function replaceWithPixelFlowButton() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  // --- Handle normal Shopify product forms ---
  if (forms.length > 1) {
    forms.forEach((form, idx) => {
      if (idx > 0) {
        form.remove();
      }
    });
  }

  forms.forEach((form, idx) => {
    if (idx > 0) return;

    // Remove default buttons + spinners + Shop Pay button
    const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"], button[type="button"]');
    buttons.forEach(btn => btn.remove());

    const spinners = form.querySelectorAll('.loading__spinner, .loading-overlay__spinner');
    spinners.forEach(spinner => spinner.remove());

    const paymentWrapper = form.querySelector('[data-shopify="payment-button"], .shopify-payment-button, .additional-checkout-buttons');
    if (paymentWrapper) paymentWrapper.remove();

    // Hide quantity selectors for Pixel Flow products
    const quantityWrappers = form.querySelectorAll('.product-quantity-wrapper, [data-product-quantity-wrapper]');
    quantityWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
      wrapper.style.visibility = 'hidden';
      wrapper.style.opacity = '0';
    });

    // Also hide any quantity wrappers outside the form
    const allQuantityWrappers = document.querySelectorAll('.product-quantity-wrapper');
    allQuantityWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
      wrapper.style.visibility = 'hidden';
      wrapper.style.opacity = '0';
    });

    // Hide size selector for specific product
    hideProductSizeSelector();

    // Insert Pixel Flow button
    insertPixelFlowBtn(form);
    
    // Re-run if variants are switched
    document.querySelectorAll("button[data-action='select-value'], .product-form__input input[type=radio]").forEach(variant => {
      variant.addEventListener('click', () => {
        setTimeout(() => replaceWithPixelFlowButton(), 200);
      });
    });
  });

  // Also hide sticky bars for Pixel Flow products
  hideStickybars();
}

async function replaceWithCustomAddToCartButton() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  // --- Handle normal Shopify product forms ---
  if (forms.length > 1) {
    forms.forEach((form, idx) => {
      if (idx > 0) {
        form.remove();
      }
    });
  }

  forms.forEach((form, idx) => {
    if (idx > 0) return;

    // Remove default buttons + spinners + Shop Pay button
    const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"], button[type="button"]');
    buttons.forEach(btn => btn.remove());

    const spinners = form.querySelectorAll('.loading__spinner, .loading-overlay__spinner');
    spinners.forEach(spinner => spinner.remove());

    const paymentWrapper = form.querySelector('[data-shopify="payment-button"], .shopify-payment-button, .additional-checkout-buttons');
    if (paymentWrapper) paymentWrapper.remove();

    // Insert our button
    insertCustomBtn(form);
    
    // Re-run if variants are switched
    document.querySelectorAll("button[data-action='select-value'], .product-form__input input[type=radio]").forEach(variant => {
      variant.addEventListener('click', () => {
        setTimeout(() => replaceWithCustomAddToCartButton(), 200);
      });
    });
  });

  // --- Handle GangSheet uploader products ---
  const gsWrapper = document.querySelector('.gs--wrapper .gs-uploader-wrapper');
  if (gsWrapper) {
    // Remove uploader and hidden add-to-cart buttons
    const uploaderBtn = gsWrapper.querySelector('#gs-uploader-btn');
    if (uploaderBtn) uploaderBtn.remove();

    const gsAddBtn = gsWrapper.querySelector('#gs-add-cart-btn');
    if (gsAddBtn) gsAddBtn.remove();

    // Insert our custom button
    insertCustomBtn(gsWrapper);
  }
}

// Helper: insert Pixel Flow button (safe, only once)
function insertPixelFlowBtn(container) {
  // Prevent duplicate buttons
  if (container.querySelector('.pixel-flow-upload-button')) {
    return; // button already exists
  }

  const customBtn = document.createElement('button');
  customBtn.type = 'button';
  customBtn.innerText = 'Upload your Designs';
  customBtn.className = 'pixel-flow-upload-button';
  customBtn.style.cssText = `
    width: 100%;
    padding: 12px;
    background: #000;
    color: #fff;
    font-size: 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 10px;
  `;

  // Prefer Shopify form button containers, else append directly
  const containerEl = container.querySelector(
    '.product-form__buttons, .product-form, .product-single__form, .product__buttons'
  );
  if (containerEl) {
    containerEl.appendChild(customBtn);
  } else {
    container.appendChild(customBtn);
  }
}

// Hide sticky bars and related elements
function hideStickybars() {
  const stickybarsSelectors = [
    '[id*="sticky-bar"]',
    '[class*="sticky-bar"]', 
    '[data-sticky="true"]',
    '.sticky-product-form',
    '.product-sticky-bar',
    '.sticky-add-to-cart',
    '.yv-product-viewbar',
    '#yvProductStickyBar'
  ];

  stickybarsSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(element => {
      element.style.display = 'none';
      element.style.visibility = 'hidden';
      element.style.opacity = '0';
      element.style.pointerEvents = 'none';
    });
  });
}

// Hide size selector for specific products
function hideProductSizeSelector() {
  // Check if current product is 7845441601752
  if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
    const product = ShopifyAnalytics.meta.product;
    if (product.id === 7845441601752) {
      const sizeSelector = document.querySelector('#ProductData-template--18885438243032__main-product > div > div.select-size.product-option-selector.no-js-hidden');
      if (sizeSelector) {
        sizeSelector.style.display = 'none';
        sizeSelector.style.visibility = 'hidden';
        sizeSelector.style.opacity = '0';
      }
    }
  }
}

// Helper: insert button (safe, only once)
function insertCustomBtn(container) {
  // Prevent duplicate buttons
  if (container.querySelector('.my-custom-add-button')) {
    return; // button already exists
  }

  const customBtn = document.createElement('button');
  customBtn.type = 'button';
  customBtn.innerText = 'Build your GangSheet';
  customBtn.className = 'my-custom-add-button';
  customBtn.style.cssText = `
    width: 100%;
    padding: 12px;
    background: #000;
    color: #fff;
    font-size: 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 10px;
  `;

  // Prefer Shopify form button containers, else append directly
  const containerEl = container.querySelector(
    '.product-form__buttons, .product-form, .product-single__form, .product__buttons'
  );
  if (containerEl) {
    containerEl.appendChild(customBtn);
  } else {
    container.appendChild(customBtn);
  }
}

async function clearCart() {
  await fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
  });
}

// Hide specific cart properties from being shown in the cart UI
function hideCartProperties() {
  const propertyLabels = document.querySelectorAll('.cart__item, .cart-item');
  propertyLabels.forEach(item => {
    const propertyRows = item.querySelectorAll('li, .cart__property, .product-option');
    propertyRows.forEach(row => {
      const text = row.textContent || '';
      if (text.includes('unique_key') || text.includes('Created At')) {
        row.style.display = 'none';
      }
    });
  });
}

async function runner() {
  const pathname = window.location.pathname;
  if (pathname.includes('/products/')) {
    if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      const product = ShopifyAnalytics.meta.product;
      console.log("Product ID:", product.id);
      console.log("Product Handle:", product.handle);
      console.log("Product Tags:", product.tags);
      
      // Check if this is a Pixel Flow product first
      // Get template suffix from current page URL or meta tags
      let templateSuffix = '';
      const templateMeta = document.querySelector('meta[name="template"]');
      if (templateMeta) {
        const template = templateMeta.content;
        if (template.includes('.')) {
          templateSuffix = template.split('.')[1];
        }
      }
      
      console.log("Template suffix:", templateSuffix);
      
      // Alternatively, check if product handle contains dtf-transfer
      const productTags = product.tags || [];
      const productHandle = product.handle || '';
      const isDtfTransfer = productHandle.includes('dtf-transfer') || templateSuffix === 'dtf-transfer';
      
      console.log("Is DTF Transfer:", isDtfTransfer);
      console.log("Is in PF list:", PFenabledProductList.includes(product.id));
      console.log("Is in GS list:", GSenabledProductList.includes(product.id));
      
      if (isPixelFlowProduct(product.id, templateSuffix, productTags) || isDtfTransfer) {
        console.log("Pixel Flow product detected");
        await replaceWithPixelFlowButton();
      } else if (GSenabledProductList.includes(product.id)) {
        console.log("GangSheet product detected");
        await replaceWithCustomAddToCartButton();
      } else {
        console.log("No special handling needed for this product");
      }
    }

  } else if (pathname === '/cart' || pathname.includes('/cart')) {
    const urlParams = new URLSearchParams(window.location.search);
    let oldVariantId = urlParams.get('oldVariantId');
    let addedItems= urlParams.get('items');
    addedItems = JSON.parse(addedItems);

    if (oldVariantId && addedItems) {
      let cart;
      try {
        const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
        cart = await cartRes.json();
      } catch (err) {
        console.error('Error fetching cart:', err);
        cart = { items: [] };
      }

      // Remove all items with oldVariantId and no canvasId
      const removalPromises = cart.items
        .filter(item => String(item.variant_id) === String(oldVariantId) && !(item.properties && item.properties.canvasId))
        .map(item => {
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          }).catch(error => {
            console.error('Error updating cart for key', item.key, error);
          });
        });

      if (removalPromises.length > 0) {
        await Promise.all(removalPromises);
      }

      // Now add new items
      let items = [];
      for (let i = 0; i < parseInt(addedItems.length); i++) {
          const timestamp = new Date().getTime() + i * 1000;
          const readableTime = new Date(timestamp).toLocaleString();
          items.push({
            id: addedItems[i].variantId,
            quantity: addedItems[i].quantity,
            properties: {
              _timestamp: timestamp,
              'Created At': readableTime,
              canvasId: addedItems[i].id,
              portalURL: 'https://gangsheetbuilder.pixelflowdtf.com/load?canvasId=' + addedItems[i].id,
              unique_key: `${addedItems[i].variantId}_${timestamp}`
            }
          });
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const result = await response.json();
        window.location.href = window.location.pathname;

      } catch (error) {
        console.error('Error adding items:', error);
      }
    }
    console.log("You're on the cart page");
  }
}

// Function to ensure runner is called
function initRunner() {
    runner().then(hideCartProperties).catch(err => console.error('Runner error:', err));
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initRunner();
}

document.addEventListener('DOMContentLoaded', initRunner);
window.addEventListener('load', initRunner);

// Event delegation for Pixel Flow upload button
function handlePixelFlowClick(event) {
  const btn = event.target.closest('.pixel-flow-upload-button');
  if (!btn) return;
  event.preventDefault();

  // Create full-screen iframe overlay
  const overlay = document.createElement('div');
  overlay.id = 'pixel-flow-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 2147483647;
    display: flex;
    flex-direction: column;
  `;

  // Create back button
  const backBtn = document.createElement('button');
  backBtn.innerHTML = '← Back';
  backBtn.style.cssText = `
    position: absolute;
    top: 8px;
    left: 8px;
    background: rgba(255,255,255,0.9);
    color: #333;
    border: 0;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0,0,0,.2);
    z-index: 2147483648;
    font-size: 12px;
    backdrop-filter: blur(4px);
    transition: all 0.2s ease;
  `;

  backBtn.addEventListener('click', function() {
    document.body.removeChild(overlay);
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  });

  // Create iframe
  const iframe = document.createElement('iframe');
  iframe.src = PFiframeUrl;
  iframe.style.cssText = `
    width: 100%;
    height: 100%;
    border: none;
    background: white;
  `;
  iframe.allow = 'clipboard-write; fullscreen';

  overlay.appendChild(backBtn);
  overlay.appendChild(iframe);
  document.body.appendChild(overlay);

  // Lock scroll
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.width = '100%';

  // Handle ESC key
  function handleEsc(e) {
    if (e.key === 'Escape') {
      backBtn.click();
      document.removeEventListener('keydown', handleEsc);
    }
  }
  document.addEventListener('keydown', handleEsc);

  // Handle iframe messages to close
  function handleMessage(e) {
    try {
      if ((e.data || {}).type === 'pf:close') {
        backBtn.click();
        window.removeEventListener('message', handleMessage);
      }
    } catch(_) {}
  }
  window.addEventListener('message', handleMessage);
}

// Event delegation for custom add-to-cart button
function handleCustomAddToCartClick(event) {
  const btn = event.target.closest('.my-custom-add-button');
  if (!btn) return;
  event.preventDefault();

  const form = btn.closest('form');
  if (!form) return;

  (async () => {
    const formData = new FormData(form);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Could not add to cart');
      }

      const alreadyCartItem = await response.json();
      console.log("alreadyCartItem", alreadyCartItem);
      try {
        let builderUrl;
        if (!!alreadyCartItem.items && (alreadyCartItem.items.length > 0)) {
          builderUrl = `https://gangsheetbuilder.pixelflowdtf.com/?productId=${alreadyCartItem.items[0].product_id}&variantId=${alreadyCartItem.items[0].variant_id}&shopId=${shopID}&url=${window.location.origin}&quantity=${alreadyCartItem.items[0].quantity}`;
        } else {
          builderUrl = `https://gangsheetbuilder.pixelflowdtf.com/?productId=${alreadyCartItem.product_id}&variantId=${alreadyCartItem.variant_id}&shopId=${shopID}&url=${window.location.origin}&quantity=${alreadyCartItem.quantity}`;
        }

        // Create iframe container
        const iframeContainer = document.createElement('div');
        iframeContainer.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 9999;
          background: white;
        `;

        const iframe = document.createElement('iframe');
        iframe.src = builderUrl;
        iframe.style.cssText = `
          width: 100%;
          height: 100%;
          border: none;
        `;

        iframeContainer.appendChild(iframe);
        document.body.appendChild(iframeContainer);
      } catch (err) {
        clearCart();
        replaceWithCustomAddToCartButton();
        console.error(err);
      }
    } catch (err) {
      replaceWithCustomAddToCartButton();
      console.error(err);
    }
  })();
}

document.addEventListener('click', handleCustomAddToCartClick);
document.addEventListener('click', handlePixelFlowClick);
